
import updatedItemsList from './updatedItemsList.js';

function getItemName(itemId) {
    if(itemId == null){
        return "Not T8 Equiv"
    }
  const enchantment = itemId.split('@')[1] ?? "";
  const tier = itemId.split('_')[0].split("T")[1];
  const itemFound = updatedItemsList.filter(item => item.itemId === itemId.split("@")[0]);

  const itemName = itemFound[0].itemName.split(" ", 5)
  if(itemName.length>1){
    itemName.shift()
    return tier+"."+enchantment+" "+itemName.join(' ');
  }
  return tier+"."+enchantment+" "+itemName[0];


}

export default getItemName;
